<template>
  <div class="sample-clothes-page">
    <!-- 顶部标签栏 -->
    <el-tabs v-model="activeTab" class="tab-header" @tab-click="aa">
      <el-tab-pane label="全部样衣" name="all"></el-tab-pane>
      <el-tab-pane label="已发布" name="published"></el-tab-pane>
      <el-tab-pane label="审核中" name="reviewing"></el-tab-pane>
      <el-tab-pane label="未通过" name="failed"></el-tab-pane>
      <el-tab-pane label="基础信息修改" name="basic"></el-tab-pane>
    </el-tabs>
    <!-- 列表区域 -->
    <div class="list-container" @scroll="handleScroll">
      <!-- 全选与计数 -->
      <div class="list-header">
        <div class="search-bar" style="position: relative; width: 600px">
          <el-input
            placeholder="搜索"
            style="width: 600px"
            v-model="searchKeyword"
            @input="saveQueryStorage"
          ></el-input>
          <img
            @click="search"
            style="
              width: 25px;
              height: 29px;
              position: absolute;
              right: 0;
              bottom: 1px;
              cursor: pointer;
            "
            :src="imgurl"
            alt=""
          />
        </div>
        <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
          >共{{ total }}项</el-checkbox
        >
        <div class="table-header">
          <span class="header-name">名称</span>
          <span class="header-time">修改时间</span>
          <span class="header-audit">审核原因</span>
          <span class="header-actions">操作</span>
        </div>
      </div>
      <!-- 列表项 -->
      <div v-for="(item, index) in sampleList" :key="index" class="list-item">
        <el-checkbox v-model="item.checked" class="item-checkbox"></el-checkbox>
        <div class="item-content">
          <div class="item-img">
            <img :src="item.coverUrl" alt="样衣图片" />
          </div>
          <div class="item-info">
            <!-- tooltip 包裹整行容器，不嵌套省略p标签 -->
            <el-tooltip
              effect="dark"
              :content="item.title"
              placement="top-start"
              popper-append-to-body
            >
              <div class="title-wrap">
                <p class="item-desc title-ellipsis">
                  产品信息：{{ item.title }}
                </p>
              </div>
            </el-tooltip>
            <p class="item-desc">
              面料信息:
              <span style="margin-left: 6px">品名/编号: {{ item.name }}</span>
              <span style="margin-left: 18px">幅宽: {{ item.width }}</span>
              <span style="margin-left: 18px">克重: {{ item.weight }}</span>
            </p>
          </div>
          <div class="item-time">{{ item.updatetime }}</div>
          <el-tooltip
            effect="dark"
            :content="item.auditContent"
            placement="top-start"
            popper-append-to-body
            ><div class="item-audit">
              {{ item.auditContent || "" }}
            </div></el-tooltip
          >
          <div class="item-actions">
            <el-button type="text" size="small" @click="handleEdit(item)"
              >编辑</el-button
            >
            <el-popconfirm
              title="确认删除该样衣吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="handleDelete(item.id)"
            >
              <template #reference>
                <el-button type="text" size="small">删除</el-button>
              </template>
            </el-popconfirm>
          </div>
        </div>
      </div>
      <!-- 底部加载状态 -->
      <div v-if="sampleList.length" class="scroll-status">
        {{ noMore ? "没有更多了~" : loading ? "加载中..." : "" }}
      </div>
    </div>
    <el-dialog
      title="修改"
      center
      width="1200px"
      v-model="showUpdate"
      custom-class="sample-clothes-dialog"
      @close="handleDialogClose"
    >
      <my-dialog
        :row="editRow"
        @update-success="handleUpdateSuccess"
        @cancel="showUpdate = false"
      />
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, nextTick, getCurrentInstance } from "vue";
import MyDialog from "./updata/user-product-launch.vue";
import srcs from "../lalian.png";
const { proxy } = getCurrentInstance();
const imgurl = srcs;
const showUpdate = ref(false);
const activeTab = ref("all");
const checkAll = ref(false);
const total = ref(0);
const sampleList = ref([]);
const numm = ref(0);
const editRow = ref(null);
const xgbs = ref(0);
const searchKeyword = ref("");

// 分页相关
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

const STORAGE_KEY = "sample_clothes_query";

// 保存查询条件到 sessionStorage
const saveQueryStorage = () => {
  const query = {
    activeTab: activeTab.value,
    searchKeyword: searchKeyword.value,
    numm: numm.value,
    xgbs: xgbs.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(query));
};

// 读取本地缓存
const loadQueryStorage = () => {
  const str = sessionStorage.getItem(STORAGE_KEY);
  if (!str) return null;
  try {
    return JSON.parse(str);
  } catch (e) {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const handleDialogClose = () => {
  editRow.value = null;
};
const handleUpdateSuccess = () => {
  showUpdate.value = false;
  reload();
};

// 搜索/切标签/编辑成功等：重置分页，从第1页重新加载
const reload = () => {
  pages.value.page = 1;
  noMore.value = false;
  sampleList.value = [];
  getlist(numm.value);
};

const getlist = async (num, isLoadMore = false) => {
  if (loading.value || noMore.value) return;
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    flag: num == 0 ? "" : num,
    complexSearch: searchKeyword.value,
  };
  if (xgbs.value == 1) {
    sendata.outdatedFlag = 1;
  }
  try {
    loading.value = true;
    const res = await proxy.$api.ProductManage.get(sendata);
    if (res.data.code == "200") {
      const currentData = res.data.data.list.map((item) => ({
        ...item,
        coverUrl: item.coverUrl?.startsWith("https")
          ? item.coverUrl
          : `https://${item.coverUrl}`,
        checked: false,
        updatetime: formatDate(item.updatetime),
      }));
      // 分页拼接逻辑
      if (pages.value.page === 1) {
        sampleList.value = currentData;
      } else {
        sampleList.value = [...sampleList.value, ...currentData];
      }
      total.value = res.data.data.total;
      // 判断是否没有更多
      noMore.value =
        res.data.data.total != null
          ? sampleList.value.length >= res.data.data.total
          : currentData.length < pages.value.size;
      pages.value.page += 1;
    }
  } catch (error) {
    if (!isLoadMore) sampleList.value = [];
    console.error("获取样衣失败：", error);
  } finally {
    loading.value = false;
  }
};

// 滚动到底部自动请求下一页
const handleScroll = (e) => {
  const { scrollTop, clientHeight, scrollHeight } = e.target;
  if (
    !noMore.value &&
    !loading.value &&
    sampleList.value.length &&
    scrollTop + clientHeight >= scrollHeight - 50
  ) {
    getlist(numm.value, true);
  }
};

const search = () => {
  reload();
};
const aa = (tab) => {
  if (tab.props.name == "all") {
    xgbs.value = 0;
    numm.value = 0;
  } else if (tab.props.name == "published") {
    xgbs.value = 0;
    numm.value = 4;
  } else if (tab.props.name == "reviewing") {
    xgbs.value = 0;
    numm.value = 2;
  } else if (tab.props.name == "basic") {
    xgbs.value = 1;
    numm.value = 0;
  } else {
    xgbs.value = 0;
    numm.value = 3;
  }
  // 切换标签后保存请求
  saveQueryStorage();
  reload();
};
const handleCheckAllChange = (val) => {
  sampleList.value.forEach((item) => {
    item.checked = val;
  });
};
const handleEdit = async (item) => {
  editRow.value = null;
  await nextTick();
  editRow.value = { ...item };
  showUpdate.value = true;
};
const handleDelete = async (id) => {
  const sendata = {
    id: id,
  };
  try {
    const res = await proxy.$api.ProductManage.del(sendata);
    if (res.data.code == "200") {
      reload();
      proxy.$message.success("删除样衣成功!");
    }
  } catch (error) {
    console.error("删除样衣失败：", error);
    proxy.$message.error("删除样衣失败，请稍后重试！");
  }
};
watch(
  sampleList,
  (val) => {
    checkAll.value = val.length > 0 && val.every((item) => item.checked);
  },
  { deep: true }
);

onMounted(() => {
  const cache = loadQueryStorage();
  if (cache) {
    activeTab.value = cache.activeTab;
    searchKeyword.value = cache.searchKeyword;
    numm.value = cache.numm;
    xgbs.value = cache.xgbs;
  }
  // 用缓存条件请求列表
  getlist(numm.value);
});
</script>

<style lang="scss">
.sample-clothes-dialog.el-dialog {
  margin-top: 0 !important;
  top: 0 !important;
}
.sample-clothes-dialog.el-dialog--center .el-dialog__body {
  height: 920px !important;
  max-height: 920px !important;
}
</style>
<style lang="scss" scoped>
.sample-clothes-page {
  background-color: #fff;
  width: 97%;
  height: 100vh;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.tab-header {
  flex-shrink: 0;
}
.tab-header :deep(.el-tabs__item) {
  font-size: 18px;
  color: #666;
  padding: 0 !important;
  text-align: center !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 120px !important;
  height: 38px !important;
  box-sizing: border-box;
}
.tab-header :deep(.el-tabs__item.is-active) {
  color: #333;
  font-weight: 500;
  border: 1px solid #d9b88c;
  border-radius: 4px;
  background-color: #fff;
}
.tab-header :deep(.el-tabs__active-bar) {
  display: none !important;
}
// 禁止tabs导航自动拉伸
.tab-header :deep(.el-tabs__nav) {
  gap: 8px;
  display: flex;
}
.list-container {
  background-color: transparent;
  flex: 1;
  overflow-y: auto;
  padding-right: 5px;
}
.list-header {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 52;
}
.table-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0 10px 30px;
  color: #666;
  font-size: 14px;
}
.header-name {
  width: 45%;
}
.header-time {
  width: 12%;
  text-align: center;
}
.header-audit {
  width: 17%;
  text-align: center;
}
.header-actions {
  width: 20%;
  text-align: right;
}
.list-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}
.item-checkbox {
  margin-right: 15px;
}
.item-content {
  display: flex;
  align-items: center;
  width: 100%;
}
.item-img {
  width: 80px;
  height: 80px;
  background-color: #f0e9d2;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}
.item-img img {
  width: 70px;
  height: 70px;
  object-fit: cover;
}
.item-info {
  flex: 1;
}
.item-desc {
  font-size: 14px;
  color: #333;
  margin: 0;
  line-height: 22px;
}
.title-wrap {
  width: 100%;
  display: block;
  cursor: pointer;
}
.title-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 44px;
}
.item-time {
  width: 18%;
  text-align: center;
  font-size: 14px;
  color: #666;
}
.item-audit {
  width: 17%;
  text-align: center;
  font-size: 14px;
  color: #666;
  // 文字超出省略...
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
}
.item-actions {
  width: 20%;
  text-align: right;
}
.item-actions .el-button {
  color: #666;
  margin-left: 15px;
}
.item-actions .el-button:hover {
  color: #d9b88c;
}
.item-actions :deep(.el-popconfirm) {
  display: inline-block;
}
.scroll-status {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 15px 0;
}
</style>
